import {
  SET_SMART_SCHEDULER_TASK_NODE,
  type SmartSchedulerActions,
} from 'src/action-creators/scheduler/smart-scheduler';
import type {SmartScheduler} from 'src/types/scheduler/smartScheduler';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';


export type SmartSchedulerState = {
  node: SmartScheduler;
};

const initialState = {
  node: {
    ...getDefaultNodeScheduleState({}),
    date_field: undefined,
    time_field: undefined,
    recurring_rule: null,
    frequency_limit_settings: null,
    task: {
      params: {
        dateSource: 'transcript' as const,
        dateValue: '',
        meetingDuration: '30',
        meetingLocation: 'custom_location' as const,
        meetingTitle: '',
        hostEmail: '',
        attendeeEmail: '',
        attendeeName: '',
        attendeePhoneNumber: '',
        candidateInviteMode: [],
        notifyHost: false,
        meetingDescription: '',
        fallbackTemplate: {
          id: '',
          name: '',
        },
      },
    },
  },
};

export default (
  state: SmartSchedulerState = initialState,
  action: SmartSchedulerActions,
) => {
  switch (action.type) {
    case SET_SMART_SCHEDULER_TASK_NODE:
      return {
        ...state,
        node: action.payload,
      };
    default:
      return state;
  }
};
